import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { billingReturn } from "../../lib/api";
import { track } from "../../lib/analytics";
import { RequireAuth } from "./guards";
import { Shell, Card, H1, Btn } from "./ui";

function Inner() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let stop = false;
    const poll = async () => {
      if (stop || !sid) return;
      try {
        const r = await billingReturn(sid);
        if (r.payment_status === "paid") { const k = r.kind === "credit_pack" ? "credits" : "subscribed"; if (k === "subscribed") track("subscription_started", { kind: r.kind || "subscription" }); setState(k); return; }
      } catch { /* keep polling */ }
      if (++tries > 12) { setState("pending"); return; }
      setTimeout(poll, 2500);
    };
    poll();
    return () => { stop = true; };
  }, [sid]);

  const done = state === "subscribed" || state === "credits";
  return (
    <Shell>
      <div className="max-w-md mx-auto mt-20 text-center" data-testid="billing-return">
        <div className="text-[#00D26A] text-xs tracking-[0.3em] uppercase mb-2">Billing</div>
        <H1>{done ? "All set" : state === "pending" ? "Almost there" : "Confirming payment…"}</H1>
        <Card className="mt-6 text-left">
          <p className="text-white/70 text-sm">
            {state === "subscribed" && "Your subscription is active. Your AI allowance and plan features are now applied."}
            {state === "credits" && "Your AI credits have been added to your account."}
            {state === "pending" && "Your payment is processing. Your account will update automatically once Stripe confirms it — this can take a few moments."}
            {state === "checking" && "We're confirming your payment with Stripe…"}
          </p>
          <div className="mt-5">
            <Btn onClick={() => nav("/dashboard")} data-testid="billing-return-dashboard" className="w-full">Go to dashboard</Btn>
          </div>
        </Card>
      </div>
    </Shell>
  );
}

export default function BillingReturn() { return <RequireAuth><Inner /></RequireAuth>; }
